const APP_LAUNCH = {
    viaplay: "viaplay://",
    spotify: "spotify://",
    netflix: "https://www.netflix.com/",
    svtplay: "https://www.svtplay.se/",
    tv4play: "https://www.tv4play.se/",
    tv4: "https://www.tv4play.se/",
    youtube: "https://www.youtube.com/",
    disney: "https://www.disneyplus.com/",
    disneyplus: "https://www.disneyplus.com/",
    hbomax: "https://play.max.com/",
    max: "https://play.max.com/",
    discoveryplus: "https://www.discoveryplus.com/",
    viafree: "https://www.viafree.se/",
    primevideo: "https://app.primevideo.com/",
    amazonprimevideo: "https://app.primevideo.com/",
    twitch: "https://www.twitch.tv/",
    plex: "https://app.plex.tv/",
};
const APP_WEB = {
    viaplay: "https://viaplay.se/",
    spotify: "https://open.spotify.com/",
};
function normalizeName(name) {
    return name.toLowerCase().replace(/[^a-z0-9]/g, "");
}
export function knownAppLaunchUrl(name) {
    if (!name)
        return undefined;
    return APP_LAUNCH[normalizeName(name)];
}
export function knownAppWebUrl(name) {
    if (!name)
        return undefined;
    const key = normalizeName(name);
    const web = APP_WEB[key];
    if (web)
        return web;
    const launch = APP_LAUNCH[key];
    return launch && /^https?:\/\//i.test(launch) ? launch : undefined;
}
